import { array, date, number, object, string } from 'yup';

export const nomineesValidations = object().shape({
  id: string(),
  firstName: string(),
  middleName: string(),
  lastName: string(),
  relationship: string().nullable(),
  dateOfBirth: date().typeError('Please enter valid date of birth').nullable(),
  percentage: number().min(0, 'Please enter valid percentage').max(100, 'Please enter valid percentage').nullable(),
  addressId: string(),
  addressLine1: string(),
  addressLine2: string(),
  city: string(),
  country: string(),
  postcode: string(),
});

export const nomineesValidationSchema = object().shape({ nominees: array().of(nomineesValidations) });

export const nomineesDefault = {
  id: '',
  firstName: '',
  middleName: '',
  lastName: '',
  relationship: '',
  dateOfBirth: null,
  percentage: 0,
  addressId: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  country: '',
  postcode: '',
};

export const nomineesDefaultValues = { nominees: [] };
